export default __webpack_public_path__ + "static/media/chat-white.855bb58b.svg";